import styled from 'styled-components';

const OVPMainWrapper = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  padding-top: 10px;
  max-width: 1800px;
  margin: 0 auto;
  background: ${(props) => props.theme.color.neutral.v100};

  // OVP Page Title Background
  &::before {
    content: '';
    background: #f4f8fa;
    margin: auto;
    width: 100%;
    height: 254px;
    position: absolute;
    top: 0;
    z-index: 0;
    @media (min-width: ${(props) => props.theme.breakpoint.md}px) {
      height: 320px;
    }
  }
`;

const OVPErrorPageWrapper = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  padding-top: 10px;
  max-width: 1800px;
  margin: 0 auto;
  background: #f4f8fa;
`;

const OVPContentWrapper = styled.div`
  position: relative;
  margin: 0 auto;
  max-width: 912px;
  width: 100%;
  padding: 50px 24px 56px;

  @media (min-width: ${(props) => props.theme.breakpoint.md}px) {
    padding: 50px 32px 56px;
  }

  @media (min-width: ${(props) => props.theme.breakpoint.lg}px) {
    padding: 90px 0 64px;
  }
`;

const OwnedVehicleName = styled.h1`
  color: #183558;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 28px;
  line-height: 28px;
  margin-bottom: 24px;
  position: relative;
  padding: 16px 0 0;
  &::before {
    content: '';
    background: #eb9f23;
    position: absolute;
    width: 32px;
    height: 4px;
    top: 0;
    left: 0;
    z-index: 1;
  }

  @media (min-width: ${(props) => props.theme.breakpoint.md}px) {
    text-transform: uppercase;
    font-weight: 700;
    font-size: 54px;
    line-height: 54px;
    margin-bottom: 38px;
  }
`;

export const AddVehicleButtonWrapper = styled.div`
  margin-top: 0;
`;

const MFEShellWrapper = styled.div`
  display: flex;
  flex-direction: column;

  // Margin between cards
  & > *:not(${AddVehicleButtonWrapper}) {
    margin: 16px 0 0;
  }
`;

export {
  OVPMainWrapper,
  OVPErrorPageWrapper,
  OVPContentWrapper,
  OwnedVehicleName,
  MFEShellWrapper,
};
